var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-step', {
    attrs: {
      "isDone": _vm.isDone,
      "title": _vm.header.title,
      "description": _vm.header.description,
      "image": _vm.header.image,
      "debug": _vm.header.debug,
      "hasInstructions": _vm.instruction ? true : false,
      "instructionPictures": _vm.instruction.pictures,
      "instructionText": _vm.instruction.text,
      "instructionTitle": _vm.instruction.title
    }
  }, [_c('file-upload-preview', {
    attrs: {
      "example": _vm.example,
      "displayFiles": _vm.files,
      "asset": _vm.asset,
      "instruction": _vm.instruction,
      "onDelete": _vm.handleDelete,
      "onUpload": _vm.handleUpload
    }
  }), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "rules": _vm.greaterThanZeroRule,
      "label": _vm.$t('objects.report.mileage'),
      "type": "number",
      "persistent-hint": "",
      "hint": _vm.$t('report.imageCockpit.detailHint'),
      "suffix": "km",
      "clearable": ""
    },
    model: {
      value: _vm.mileage,
      callback: function callback($$v) {
        _vm.mileage = _vm._n($$v);
      },
      expression: "mileage"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }